import { VIEW_CTX } from '../constants';

export const hasItemWithPropertyEqualsTrue = (list, boolProperty) => {
  if (!list) return;
  return list.some(item => item[boolProperty] === true);
};

export const itemIsAreadySelected = ({
  selected: oldObject = {},
  toSelect: newObject = {},
  property: propertyToCompare = 'id',
}) => {
  return oldObject[propertyToCompare] === newObject[propertyToCompare];
};

export const applyBusinessRulesToContext = ({ context, list: vehicleList }) => {
  const result = {
    authorized: true,
    errorMessage: '',
  };

  if (context === VIEW_CTX.vehicles) {
    // Para veículos, a propriedade padrão é "boAtivo"
    const hasActive = hasItemWithPropertyEqualsTrue(vehicleList, 'boAtivo');
    if (hasActive) {
      result.authorized = false;
      result.errorMessage =
        'Já existe um veículo ativo na lista de veículos. Para adicionar outro veículo, inative o veículo atual da lista.';
    }
  }

  // if (context === VIEW_CTX.searchActualPermissionary) {
  //   // Para transferencias, não podem ser selecionados o mesmo
  //   // permissionário atual e substituto.
  //   const isAlreadySelected = itemIsAreadySelected(vehicleList, 'boAtivo');
  //   if (isAlreadySelected) {
  //     result.authorized = false;
  //     result.errorMessage = 'Este permissionário já foi selecionado como atual ou substituto.';
  //   }
  // }
  return result;
};
